import { render, staticRenderFns } from "./comparepopup.vue?vue&type=template&id=2aaf5e7e&scoped=true&"
import script from "./comparepopup.vue?vue&type=script&lang=js&"
export * from "./comparepopup.vue?vue&type=script&lang=js&"
import style0 from "./comparepopup.vue?vue&type=style&index=0&id=2aaf5e7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aaf5e7e",
  null
  
)

export default component.exports